import { treatValue } from './moneyTreatments';

export function convertCoinsPurchaseRatioToPercent(
  coinsPurchaseRatio: string | number
) {
  const ratio =
    typeof coinsPurchaseRatio === 'string'
      ? Number(coinsPurchaseRatio)
      : coinsPurchaseRatio;
  if (ratio === 0) return 0;
  return Math.round(
    (1 / ratio) * 100 // "converts "1 coin each $20" into "5% loyalty"
  );
}

export function convertCoinsPurchasePercentToRatio(
  coinsPurchasePercent: string | number
) {
  const percent =
    typeof coinsPurchasePercent === 'string'
      ? Number(coinsPurchasePercent)
      : coinsPurchasePercent;
  return 1 / (percent / 100);
}

export function formatTotalAndPendingCoins(total: string, pending: string) {
  return total + (pending != '0' ? ` (+${pending} pending)` : '');
}
